import { render } from "./EmployeesFamily.vue?vue&type=template&id=4287ebdd&scoped=true"
import script from "./EmployeesFamily.vue?vue&type=script&lang=js"
export * from "./EmployeesFamily.vue?vue&type=script&lang=js"

import "./EmployeesFamily.vue?vue&type=style&index=0&id=4287ebdd&scoped=true&lang=css"
import "./EmployeesFamily.vue?vue&type=style&index=1&id=4287ebdd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4287ebdd"]])

export default __exports__